const HIDE_CHANGE_MERCHANT_POPUP = 'HIDE_CHANGE_MERCHANT_POPUP';

export {HIDE_CHANGE_MERCHANT_POPUP}